import { render, staticRenderFns } from "./clusters_deprecation_alert.vue?vue&type=template&id=5bc33a48"
import script from "./clusters_deprecation_alert.vue?vue&type=script&lang=js"
export * from "./clusters_deprecation_alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports